// extracted by mini-css-extract-plugin
export default {"card":"Invite_card__6+F--","alert":"Invite_alert__etbig","logo":"Invite_logo__eYJ-o","formContainer":"Invite_formContainer__F-G-M"};